import { useTranslation } from "react-i18next";
import Chip from "@Components/Decor/Chip";
import Tag from "@Components/Decor/Tag";
import { CorrectIcon } from "@Icons/MainIcons";
import BoltIcon from "@Icons/MainIcons/BoltIcon";
import Star from "@Icons/MainIcons/StarIcon";
import Skewer from "@Components/Decor/Skewer";
import IconHolder from "@Components/Decor/IconHolder";
import Float from "@Components/Decor/Float";
import HeroCard from "../HeroCard/HeroCard";

function GiftcardsIllustration() {
  const { t } = useTranslation();

  return (
    <div
      className="giftcards-hero-decor-scroll pointer-events-none absolute end-0 top-6 h-20 w-28 shrink-0 lg:relative lg:end-auto lg:top-auto lg:h-64 lg:w-96"
      aria-hidden
    >
      <div className="scale-30 rtl:origin-top-left absolute end-0 top-0 h-64 w-96 origin-top-right lg:scale-100">
        <Skewer angle={14} className="absolute -end-4 -top-2 bg-transparent! p-0! opacity-50">
          <Float duration={6} delay={-2.5} distance={-6}>
            <HeroCard className="bg-background-primary-light! shadow-none!" circleClassName="bg-background-primary-lighter" />
          </Float>
        </Skewer>
        <Skewer angle={-4} className="absolute end-2 top-4 bg-transparent! p-0!">
          <Float duration={5} delay={-1}>
            <HeroCard />
          </Float>
        </Skewer>
        <Skewer angle={-10} className="absolute start-14 top-14 bg-transparent! p-0! not-italic">
          <Float duration={5.5} distance={-10}>
            <HeroCard
              className="bg-background-primary!"
              circleClassName="bg-background-primary-dark opacity-40"
              label={t("Giftcards.hero.cardLabel")}
              title={t("Giftcards.hero.cardTitle")}
              subtitle={t("Giftcards.hero.cardSubtitle")}
            />
          </Float>
        </Skewer>

        <div className="absolute start-12 top-10">
          <Float duration={4} delay={-1.2} distance={-6}>
            <IconHolder icon={<Star className="aspect-square w-8 p-2" />} />
          </Float>
        </div>
      </div>

      <div className="absolute inset-0 hidden lg:block">
        <div className="absolute -start-36 top-36">
          <Float duration={4.5} delay={-3}>
            <Skewer angle={5}>
              <Tag
                className="px-3! py-2!"
                title={<span className="text-sm">{t("Giftcards.hero.deliveredTitle")}</span>}
                subtitle={t("Giftcards.hero.deliveredSubtitle")}
                icon={<BoltIcon className="bg-background-primary-lighter text-font-active h-full w-full rounded-full p-2" />}
              />
            </Skewer>
          </Float>
        </div>
        <div className="absolute end-0 top-56">
          <Float duration={3.5} delay={-0.6} distance={-6}>
            <Chip
              title={t("Giftcards.hero.ready")}
              icon={<CorrectIcon className="h-3 w-3 text-white" />}
              className="bg-background-primary! text-white! outline-none!"
            />
          </Float>
        </div>
      </div>
    </div>
  );
}

export default function GiftcardsHero() {
  const { t } = useTranslation();

  return (
    <div className="relative flex w-full items-center justify-between gap-8">
      <div className="flex flex-col gap-4">
        <Chip title={t("Giftcards.hero.badge")} icon={<Star className="h-3 w-3" />} className="text-xs! outline-none!" />
        <h1 className="font-poppins text-font-default text-4xl font-semibold md:text-5xl">{t("Giftcards.title")}</h1>
        <p className="text-font-subtle text-sm leading-loose md:text-base">
          {t("Giftcards.hero.subtitle")}{" "}
          <Skewer angle={3} className="px-2 py-1 font-bold!">
            {t("Giftcards.hero.highlight")}
          </Skewer>
        </p>
      </div>
      <GiftcardsIllustration />
    </div>
  );
}
